// Strings merged ON TOP of translations.js (deep-merge by LanguageProvider).
// Contains recent copy changes + overrides (returns delay removed; curation positioning — client does not design).
export const EXTRA = {
  fr: {
    common: {
      wishlistSoon: "La wishlist arrive bientôt.",
      videoPending: "Vidéo produit à venir",
    },
    home: {
      selection: {
        title: "La Sélection MIORA",
        sub: "Chaque pièce en mouvement — voyez le tombé, la matière, la coupe.",
      },
      homeFaq: { title: "Questions fréquentes", sub: "Le service MIORA, en peu de mots.", cta: "Toutes les questions" },
    },
    product: {
      shippingBody: "Livraison standard 40 DH, offerte dès 600 DH — délais indicatifs de 2 à 4 jours ouvrables. Retours acceptés, pièce non portée — détails sur la page Retours.",
    },
    faq: {
      items: {
        returns: [
          { q: "Comment retourner une pièce ?", a: "La pièce doit être non portée, avec ses étiquettes — les modalités détaillées sont sur la page Retours." },
          { q: "Les retours sont-ils payants ?", a: "Les frais de retour restent à votre charge, sauf article défectueux — échange alors offert." },
        ],
      },
    },
    returns: {
      r1Body: "Le délai de retour sera précisé prochainement.",
    },
    footer: {
      shipStrip: "Livraison partout au Maroc",
      codStrip: "Paiement à la livraison",
    },
  },
  en: {
    common: {
      wishlistSoon: "Wishlist coming soon.",
      videoPending: "Product video to come",
    },
    home: {
      selection: {
        title: "The MIORA Edit",
        sub: "Every piece in motion — see the drape, the fabric, the fit.",
      },
      homeFaq: { title: "Frequently asked", sub: "The MIORA service, in few words.", cta: "All questions" },
    },
    product: {
      shippingBody: "Standard delivery 40 DH, free over 600 DH — indicative 2 to 4 business days. Returns accepted, unworn — see the Returns page.",
    },
    faq: {
      items: {
        returns: [
          { q: "How do I return a piece?", a: "The piece must be unworn, with its tags — full details on the Returns page." },
          { q: "Are returns paid?", a: "Return shipping is at your expense, except for faulty items — exchange then offered free." },
        ],
      },
    },
    returns: {
      r1Body: "The return window will be announced shortly.",
    },
    footer: {
      shipStrip: "Delivery across Morocco",
      codStrip: "Cash on delivery",
    },
  },
  ar: {
    common: {
      wishlistSoon: "قائمة الرغبات قريبًا.",
      videoPending: "فيديو المنتج قريبًا",
    },
    home: {
      selection: {
        title: "مختارات ميورا",
        sub: "كل قطعة في حركة — شاهدي الانسدال والقماش والقصّة.",
      },
      homeFaq: { title: "أسئلة متكررة", sub: "خدمة ميورا بكلمات قليلة.", cta: "كل الأسئلة" },
    },
    product: {
      shippingBody: "التوصيل القياسي 40 درهمًا، مجانًا فوق 600 درهم — مدة تقديرية من 2 إلى 4 أيام عمل. الإرجاع مقبول دون ارتداء — التفاصيل في صفحة الإرجاع.",
    },
    faq: {
      items: {
        returns: [
          { q: "كيف أُرجع قطعة؟", a: "يجب أن تكون القطعة غير مرتدية وببطاقاتها — التفاصيل الكاملة في صفحة الإرجاع." },
          { q: "هل الإرجاع مجاني؟", a: "رسوم الإرجاع على عهدتكما، ما عدا القطع المعيبة — فيُقدَّم التبادل مجانًا." },
        ],
      },
    },
    returns: {
      r1Body: "سيُعلن عن مدة الإرجاع قريبًا.",
    },
    footer: {
      shipStrip: "توصيل في جميع أنحاء المغرب",
      codStrip: "الدفع عند الاستلام",
    },
  },
};
